import { color_logo } from "constant/imagePath";
import { isMobileDevice, isInStandaloneMode } from "@/utils";
import classes from "./PwaGuard.module.css";

export default function PwaGuard({ children }) {
  if (!isMobileDevice() || isInStandaloneMode()) {
    return children;
  }

  const isIOS =
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

  return (
    <div className={classes.container}>
      <img src={color_logo} alt="Fluency Compass" className={classes.logo} />

      <h1 className={classes.title}>Install the App to Take Your Test</h1>
      <p className={classes.subtitle}>
        Tests must be taken from the Fluency Compass app installed on your
        device. This prevents the screen from exiting fullscreen during your
        test.
      </p>

      <div className={classes.stepsCard}>
        {isIOS ? (
          <>
            <h2 className={classes.stepsTitle}>
              How to install on iPad / iPhone
            </h2>
            <ol className={classes.steps}>
              <li>
                Open this page in <strong>Safari</strong> (not Chrome or
                another browser)
              </li>
              <li>
                Tap the{" "}
                <span className={classes.icon}>
                  <ShareIcon />
                </span>{" "}
                <strong>Share</strong> button at the bottom of the screen
              </li>
              <li>
                Scroll down and tap{" "}
                <strong>"Add to Home Screen"</strong>
              </li>
              <li>
                Tap <strong>Add</strong> in the top-right corner
              </li>
              <li>
                Open the <strong>Fluency Compass</strong> icon from your home
                screen and navigate back to your test
              </li>
            </ol>
          </>
        ) : (
          <>
            <h2 className={classes.stepsTitle}>How to install on Android</h2>
            <ol className={classes.steps}>
              <li>
                Tap the <strong>⋮ menu</strong> in the top-right corner of
                Chrome
              </li>
              <li>
                Tap <strong>"Add to Home screen"</strong> or{" "}
                <strong>"Install app"</strong>
              </li>
              <li>
                Tap <strong>Install</strong> to confirm
              </li>
              <li>
                Open the <strong>Fluency Compass</strong> icon from your home
                screen and navigate back to your test
              </li>
            </ol>
          </>
        )}
      </div>
    </div>
  );
}

function ShareIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="18"
      height="18"
      fill="currentColor"
      style={{ verticalAlign: "middle", display: "inline-block" }}
    >
      <path d="M12 2l-4 4h3v7h2V6h3l-4-4zm-6 14v4h12v-4h-2v2H8v-2H6z" />
    </svg>
  );
}
